import { type ContactUsFormValues } from "@/components/ContactUsModal/types";
import createEntityForm from "@/entity/factory/createEntityForm";

export const {
  EntityFormComponent: ContactUsFormProvider,
  useEntityForm: useContactUsForm,
  useEntityFormState: useContactUsFormState,
} = createEntityForm<ContactUsFormValues>();
